import { styled } from '@mui/material/styles';
import { DialogActions, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const PREFIX = 'OnboardProvider';

const classes = {
  footer: `${PREFIX}-footer`,
  button: `${PREFIX}-button`,
};

const Root = styled(DialogActions)(({ theme }) => ({
  [`&.${classes.footer}`]: {
    backgroundColor: 'rgba(1, 16, 18, 0.04)',
    [theme.breakpoints.up('sm')]: {
      justifyContent: 'start',
      paddingLeft: 144,
      paddingright: 144,
      paddingTop: 32,
      paddingBottom: 32,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },

  [`& .${classes.button}`]: {
    [theme.breakpoints.down('sm')]: {
      alignSelf: 'stretch',
      marginLeft: 0,
      '&:not(:last-child)': {
        marginBottom: theme.spacing(1),
      },
    },
  },
}));

interface RegisterFooterProps {
  activeStep: number;
  isFirst: boolean;
  isLast: boolean;
  isSaving: boolean;
  next: () => void;
  previous: () => void;
  saveAndClose: () => void;
  submit: () => void;
}

export default function RegisterFooter({
  activeStep,
  isFirst,
  isLast,
  isSaving,
  next,
  previous,
  saveAndClose,
  submit,
}: RegisterFooterProps) {
  const { t } = useTranslation('common');

  return (
    <Root className={classes.footer}>
      {!isFirst && !isLast && (
        <Button
          color="primary"
          variant="contained"
          disabled={isSaving}
          className={classes.button}
          onClick={previous}>
          {t('onboard.previous')}
        </Button>
      )}
      {!isLast && activeStep !== 2 && (
        <Button
          color="primary"
          variant="contained"
          disabled={isSaving}
          className={classes.button}
          onClick={next}>
          {t('onboard.next')}
        </Button>
      )}
      {(activeStep === 2 || isLast) && (
        <Button
          color="primary"
          variant="contained"
          disabled={isSaving}
          className={classes.button}
          onClick={submit}>
          {t('onboard.submit')}
        </Button>
      )}
      <Button
        color="secondary"
        variant="contained"
        disabled={isSaving}
        className={classes.button}
        onClick={saveAndClose}>
        {t(isLast ? 'onboard.close' : 'onboard.saveAndClose')}
      </Button>
    </Root>
  );
}
